import { Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import DataCell from "./DataCell";
import { getOrderDetails } from "@/utils/order";
import { Order, OrderItem } from "@/types";

interface Props {
  order: Order;
}

const KitchenOrder = ({ order }: Props) => {
  return (
    <Stack padding={3} spacing={2}>
      <Stack spacing={1}>
        <Typography>Restaurante</Typography>
        <DataCell label="Orden" value={order?.number as unknown as string} />
        <DataCell label="Hora" value={order?.createdAt ? format(order.createdAt, "p") : "N/A"} />
        <DataCell label="Fecha" value={order?.createdAt ? format(order.createdAt, "MM/dd/yyyy") : "N/A"} />
        <DataCell label="Tipo" value="" />
        {/* <DataCell label="Mesa" value="" />
        <DataCell label="Mesero" value="" /> */}
      </Stack>
      <Stack direction={"row"} justifyContent={"space-between"} borderTop={1} borderBottom={1}>
        <Typography> C. Items</Typography>
        <Typography>Montos</Typography>
      </Stack>
      {order?.items?.map((item: OrderItem) => (
        <Stack key={item.id} spacing={2}>
          <Stack direction={"row"} spacing={2} justifyContent={"space-between"}>
            <Stack spacing={2} direction={"row"}>
              <Typography flex={1}>{item.quantity}</Typography>
              <div>
                <Typography flex={1}>{item.title}</Typography>
                <Typography>{getOrderDetails(item)}</Typography>
              </div>
            </Stack>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};

export default KitchenOrder;
